import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StaffComponent } from 'src/app/view/staff/staff.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    StaffComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild([
      {path:'', component:StaffComponent}
    ])
  ]
})
export class StaffModule { }
